import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search,searchCountry,searchState) => {
  return await GET(
    `/admin/masters/city?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&searchCountry=${
        searchCountry || ""
      }&searchState=${
        searchState || ""
      }`
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/masters/city/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/masters/city`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/masters/city/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/masters/city/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/masters/city/${id}`);
};
